<template>
  <b-container fluid>
    <iq-card>
      <template v-slot:headerTitle>
        <h4 class="card-title"> {{ $t('report_management.training_material') + ' ' + $t('globalTrans.report') }} </h4>
      </template>
      <template v-slot:body>
          <b-row>
            <b-col lg="6" sm="12">
                <b-form-group
                    class="row"
                    label-cols-sm="3"
                    label-for="fiscal_year_id"
                    >
                    <template v-slot:label>
                        {{ $t('globalTrans.fiscal_year') }}
                    </template>
                    <b-form-select
                    plain
                    v-model="search.fiscal_year_id"
                    id="fiscal_year_id"
                    :options="fiscalYearList"
                    >
                    <template v-slot:first>
                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                    </template>
                    </b-form-select>
                </b-form-group>
            </b-col>
            <b-col lg="6" sm="12">
              <b-form-group
                  class="row"
                  label-cols-sm="3"
                  label-for="circular_id"
                  >
                  <template v-slot:label>
                      {{ $t('trainer_trainee.circular_memo_no') }}
                  </template>
                  <b-form-select
                  plain
                  v-model="search.circular_id"
                  id="circular_id"
                  :options="circularMemoList"
                  >
                  <template v-slot:first>
                      <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                  </template>
                  </b-form-select>
              </b-form-group>
            </b-col>
            <b-col lg="6" sm="12">
              <b-form-group
                class="row"
                label-cols-sm="3"
                label-for="training_name_id"
                >
                <template v-slot:label>
                    {{ $t('trainer_trainee.training_title') }}
                </template>
                  <b-form-select
                  plain
                  v-model="search.training_name_id"
                  id="training_name_id"
                  :options="trainingTitleList"
                  >
                  <template v-slot:first>
                  <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                  </template>
                  </b-form-select>
              </b-form-group>
            </b-col>
            <b-col lg="6" sm="12">
              <b-spinner v-if="spinLoader" class="overlay" variant="success" small label="Spinning"></b-spinner>
              <b-form-group
                  class="row"
                  label-cols-sm="3"
                  label-for="batch_id"
                  >
                  <template v-slot:label>
                      {{ $t('trainer_trainee.batch') }}
                  </template>
                  <b-form-select
                  plain
                  v-model="search.batch_id"
                  id="batch_id"
                  :options="batchList"
                  >
                  <template v-slot:first>
                  <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                  </template>
                  </b-form-select>
              </b-form-group>
            </b-col>
            <b-col cols="12" class="text-left">
              <b-button type="button" variant="primary" @click="searchData">{{ $t('globalTrans.search')}}</b-button>
            </b-col>
          </b-row>
      </template>
    </iq-card>
    <b-row>
      <b-col md="12">
        <iq-card>
            <template v-slot:body>
                <b-row v-if="loaded">
                  <b-col xs="12" sm="12" md="12" class="mt-4 text-right">
                    <b-button-group class="pr-2">
                      <b-button @click="pdfExport" variant="success">{{  $t('globalTrans.export_pdf') }}</b-button>
                      <b-button variant="warning">
                        <export-excel
                          :data="excelData"
                          :title="headerValue"
                          worksheet="Report Sheet"
                          name="training-material-report.xls">
                          {{ $t('globalTrans.export_excel') }}
                        </export-excel>
                      </b-button>
                    </b-button-group>
                  </b-col>
                  <b-col xs="12" sm="12" md="12" class="text-center mt-3">
                    <b-img :src="`${ reportHeadData.reportHeadColumn[2].image }`" fluid alt="BD Image" style="width:7%;border-radius:50%;"></b-img>
                  </b-col>
                    <b-col xs="12" sm="12" md="3" class="text-right mt-3">
                    <b-img :src="`${ reportHeadData.reportHeadColumn[0].image }`" fluid alt="BD Image" style="width:35%;border-radius:50%;"></b-img>
                    </b-col>
                    <b-col xs="12" sm="12" md="6" class="text-center mt-2">
                      <h3 class="text-bold">{{ $t('production_store.govt_info') }}</h3>
                      <h4 class="text-center text-dark">{{ reportHeadData.orgName }}</h4>
                      <span class="text-center text-dark">{{ reportHeadData.heading }}</span><br>
                      <span class="text-center text-dark">{{ reportHeadData.address }}</span><br>
                      <div class="titleDiv">
                        <span class="text-center text-dark reportTitle" style="font-weight:bold;">{{ $t('report_management.training_material') + ' ' + $t('globalTrans.report') }}</span><br>
                      </div>
                    </b-col>
                    <b-col xs="12" sm="12" md="12" class="mt-4 mb-1">
                        <b-row>
                            <b-col xs="12" sm="12" md="6" class="text-left">
                            <div v-if="search.fiscal_year_id" class="text-dark"><b>{{ $t('globalTrans.fiscal_year') }} </b>: {{ getFiscalYear(search.fiscal_year_id) }}</div>
                            <div v-if="search.circular_id" class="text-dark"><b>{{ $t('trainer_trainee.circular_memo_no') }} </b>: {{ getCircularMemo(search.circular_id) }}</div>
                            </b-col>
                            <b-col xs="12" sm="12" md="6" class="text-right">
                            <span v-if="search.training_name_id" class="text-center text-dark"><b>{{ $t('trainer_trainee.training_title') }} </b>: {{ getTraining(search.training_name_id) }} </span><br/>
                            <span v-if="search.batch_id" class="text-center text-dark"><b>{{ $t('trainer_trainee.batch') }} </b>: {{ getBatch(search.batch_id) }} </span>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col lg="12" sm="12" v-if="traineeList.length > 0">
                      <b-overlay :show="customLoading">
                          <b-table-simple striped bordered responsive>
                              <thead>
                                <tr>
                                    <th rowspan="2">{{ $t('globalTrans.sl_no')}}</th>
                                   <th rowspan="2">{{ $t('trainer_trainee.training_title') }}</th>
                                    <th rowspan="2">{{ $t('trainer_trainee.batch') }}</th>
                                    <th rowspan="2">{{ $t('tp_management.material_name') + ' ' + $t('globalTrans.and') + ' ' + $t('globalTrans.quantity') }}</th>
                                   <!--  <th rowspan="2">{{ $t('globalTrans.quantity') }}</th>-->
                                    <th rowspan="2">{{ $t('tp_management.total_cost') }}</th>
                                    <th rowspan="2">{{ $t('application_management.remarks') }}</th>
                                </tr>
                              </thead>
                              <b-tr v-for="(item, index) in traineeList" :key="index">
                                <td>{{ $n(index + 1) }}</td>
                                <td v-if="item.training_name_id">{{ getTraining(item.training_name_id) }}</td>
                                <td v-if="item.batch_id">{{ getBatch(item.batch_id) }}</td>
                                <td v-if="item.details[0]">
                                    <span v-for="(item2, index2) in item.details" :key="index2">
                                      <span v-if="index2 != 0">, <br> </span>
                                      {{ (currentLocale === 'bn' ? item2.material_name_bn : item2.material_name) + ' - ' + $n(item2.quantity, { useGrouping: false }) }}
                                    </span>
                                </td>
                             <!--    <td v-if="item.details[0]">
                                    <span v-for="(item2, index2) in item.details" :key="index2"><span v-if="index2 != 0">, </span> {{ $n(item2.quantity, { useGrouping: false }) }}</span>
                                </td>-->
                                <td>{{ $n(item.total_cost) }}</td>
                                <td>{{ item.remarks }}</td>
                              </b-tr>
                          </b-table-simple>
                      </b-overlay>
                    </b-col>
                    <b-col v-else>
                          <b-table-simple>
                              <b-tr>
                                  <td colspan="6" class="align-middle text-center">{{ $t('globalTrans.noDataFound') }}</td>
                              </b-tr>
                          </b-table-simple>
                    </b-col>
                </b-row>
            </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import Excel from './export-excel'
import RestApi, { trainingElearningServiceBaseUrl } from '@/config/api_config'
import { trainingMaterialReportApi } from '../../api/routes'
import RouteBasedList from '@/mixins/route-base-list'
import ExportPdf from './export-pdf'
import ReportHeading from '@/Utils/report-head'
import excel from 'vue-excel-export'
import Vue from 'vue'
Vue.use(excel)

export default {
  mixins: [RouteBasedList],
  components: {
  },
  data () {
    return {
      search: {
        fiscal_year_id: 0,
        circular_id: 0,
        training_name_id: 0,
        batch_id: 0
      },
      spinLoader: false,
      batchList: [],
      tmpBatchList: [],
      circularMemoList: [],
      trainingTitleList: [],
      loaded: false,
      notFound: true,
      traineeList: [],
      alreadyExist: [],
      timeRange: [],
      customLoading: false,
      reportHeadData: ''
    }
  },
  watch: {
    'search.fiscal_year_id': function (newVal, oldVal) {
      this.circularMemoList = this.getMomoList(newVal)
      this.search.circular_id = 0
      this.search.training_name_id = 0
      this.trainingTitleList = []
    },
    'search.circular_id': function (newVal, oldVal) {
      this.trainingTitleList = this.getTrainingTitle(newVal)
      this.getCircularData()
    },
    currentLocale: function (newVal, oldVal) {
        if (newVal !== oldVal) {
            this.trainingTitleList = this.search.circular_id ? this.getTrainingTitle(this.search.circular_id) : []
            this.getBatchList()
            this.headerName()
        }
    }
  },
  computed: {
    headerValue: function () {
      const title = this.$t('report_management.training_material') + ' ' + this.$t('globalTrans.report')
      return Excel.headerData(this, title)
    },
    excelData: function () {
      return Excel.excelBody(this)
    },
    fiscalYearList: function () {
      return this.$store.state.commonObj.fiscalYearList.filter(item => item.status === 0)
    },
    currentLocale () {
      return this.$i18n.locale
    }
  },
  created () {
    this.headerName()
  },
  mounted () {
  },
  methods: {
    async getCircularData () {
        if (this.search.fiscal_year_id && this.search.circular_id) {
            this.spinLoader = true
            const params = {
            fiscal_year_id: this.search.fiscal_year_id,
            circular_id: this.search.circular_id
            }
            const result = await RestApi.getData(trainingElearningServiceBaseUrl, 'training-plan-management/training-routine/circular-data', params)
            if (result.success) {
                if (result.training) {
                    this.search.training_name_id = result.training
                }
                this.tmpBatchList = result.batch
                this.getBatchList()
            }
            this.spinLoader = false
        }
    },
    getBatchList () {
        if (this.tmpBatchList.length > 0) {
            this.batchList = this.tmpBatchList.map((item, index) => {
                return Object.assign({}, { value: item.batch_d.id, text: this.$i18n.locale === 'en' ? item.batch_d.batch : item.batch_d.batch_bn })
            })
        } else {
            this.batchList = []
        }
    },
    searchData () {
      this.loadData()
    },
    loadData () {
      this.customLoading = true
      const params = Object.assign({}, this.search)
      RestApi.getData(trainingElearningServiceBaseUrl, trainingMaterialReportApi, params).then(response => {
          if (response.warning) {
            this.customLoading = false
            this.$toast.error({
              title: 'warning',
              message: response.message
            })
            return
          }
          if (response.success) {
            this.customLoading = false
              this.traineeList = response.data
              if (response.data.details.length === 0) {
                this.notFound = true
              } else {
                this.notFound = false
              }
          } else {
            this.customLoading = false
            this.traineeList = []
          }
        this.customLoading = false
      })
    },
    async headerName () {
      const headdata = await ReportHeading.getReportHead(trainingElearningServiceBaseUrl, 'config/report-heading/detail', 4)
      this.reportHeadData = headdata
      this.loaded = true
    },
    pdfExport () {
      const reportTitle = this.$t('report_management.training_material') + ' ' + this.$t('globalTrans.report')
      ExportPdf.exportPdfDetails(trainingElearningServiceBaseUrl, 'config/report-heading/detail', 4, reportTitle, this.traineeList, this, this.search)
    },
    generateDateList (startDate, endDate) {
      var now = startDate.clone()
      var dates = []
      while (now.isSameOrBefore(endDate)) {
        dates.push(now.format('YYYY-MM-DD'))
        now.add(1, 'days')
      }
      this.timeRange = dates
    },
    getMomoList (fiscalYearId) {
      return this.$store.state.TrainingElearning.commonObj.circularMemoList.filter(item => item.fiscal_year_id === fiscalYearId).map(item => {
        if (this.$i18n.locale === 'bn') {
          return { value: item.value, text: item.text_bn }
        } else {
          return { value: item.value, text: item.text_en }
        }
      })
    },
    getTrainingTitle (circularMemoId) {
      const trainingObj = this.$store.state.TrainingElearning.commonObj.circularMemoList.find(item => item.value === circularMemoId)
      return this.$store.state.TrainingElearning.commonObj.trainingNameList.filter(item => item.status === 1 && item.value === trainingObj.training_title_id).map(item => {
        if (this.$i18n.locale === 'bn') {
          return { value: item.value, text: item.text_bn }
        } else {
          return { value: item.value, text: item.text_en }
        }
      })
    },
    getFiscalYear (fiscalYearId) {
      if (fiscalYearId) {
        const fiscalObj = this.fiscalYearList.find(item => item.value === fiscalYearId)
        return fiscalObj.text
      }
    },
    getCircularMemo (circularMemoId) {
      const circularObj = this.$store.state.TrainingElearning.commonObj.circularMemoList.find(item => item.value === circularMemoId)
      if (this.$i18n.locale === 'bn') {
        return circularObj.text_bn
      } else {
        return circularObj.text_en
      }
    },
    getTraining (trainingId) {
      const trainingObj = this.$store.state.TrainingElearning.commonObj.trainingNameList.find(item => item.value === trainingId)
      if (this.$i18n.locale === 'bn') {
        return trainingObj.text_bn
      } else {
        return trainingObj.text_en
      }
    },
    getBatch (batchId) {
      const batchObj = this.$store.state.TrainingElearning.commonObj.batchList.find(item => item.value === batchId)
      if (this.$i18n.locale === 'bn') {
        return batchObj.text_bn
      } else {
        return batchObj.text_en
      }
    },
    getDesignation (designationId) {
      const designationObj = this.$store.state.TrainingElearning.commonObj.designationList.find(item => item.value === designationId)
      if (designationObj !== undefined) {
          if (this.$i18n.locale === 'bn') {
            return designationObj.text_bn
          } else {
            return designationObj.text
          }
      }
    },
    getOrgName (id) {
     if (id) {
       const obj = this.$store.state.commonObj.organizationProfileList.find(item => item.value === id)
       if (this.$i18n.locale === 'bn') {
         return obj.text_bn
       } else {
         return obj.text
       }
     } else {
      return id
     }
    },
    getPresentAbsent (batchScheduleId, traineeId, attendanceData) {
      const present = this.alreadyExist.find(item => item.batch_schedule_id === batchScheduleId && item.trainee_id === traineeId && item.attendance_date === attendanceData)
      if (present === undefined) {
        return this.$t('tp_management.absent')
      } else {
        return this.$t('tp_management.present')
      }
    }
  }
}
</script>
<style scoped>
.overlay {
    position: absolute;
    left: 65%;
    z-index: 9999;
    top: 10px;
    text-align: center;
}
</style>
